<h2 mat-dialog-title>
    @if (data.isSolicitud) {
        Información sobre la solicitud
    } @else {
        Información sobre la incidencia
    }
</h2>
<mat-dialog-content class="tipo-incidencia-info-dialog__body">
    <div class="tipo-incidencia-info-dialog__html" [innerHTML]="data.html"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cerrar()">Cerrar</button>
</mat-dialog-actions>
